import styled, { css } from 'styled-components';

import { MediaQueries, Colors } from 'environment';
import { Cell as DefaultCell } from 'components/UI/Table/Table.style';
import { Table } from 'components/UI/Table';

const isOnTouchDevice = 'ontouchstart' in document.documentElement;

export const Container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: calc(100vh - 26rem);
`;

interface CellStyleProps {
	menuVisible?: boolean;
	isFrozen?: boolean;
}

export const Cell = styled(DefaultCell)<CellStyleProps>`
	.custom-dropdown-container:hover > div {
		color: initial;
	}
	${({ menuVisible, isFrozen }) =>
		menuVisible &&
		!isFrozen &&
		css`
			background-color: ${Colors.primary.disabled};
			.custom-dropdown-container > div {
				color: ${Colors.primary.normal};
			}
			.card-more-icon {
				visibility: visible;
			}
		`}

	.card-more-icon {
		visibility: ${({ menuVisible, isFrozen }) =>
			menuVisible && !isFrozen ? 'visible' : 'hidden'};
	}

	${isOnTouchDevice &&
	css<CellStyleProps>`
		${({ isFrozen }) =>
			!isFrozen &&
			css`
				.card-more-icon {
					visibility: visible;
				}
			`}
	`}

	&:hover {
		${({ isFrozen, menuVisible }) =>
			!isFrozen &&
			css`
				cursor: pointer;

				.card-more-icon {
					visibility: visible;
				}

				${menuVisible &&
				css`
					.custom-dropdown-container > div {
						color: ${Colors.primary.normal};
					}
				`}
			`}
	}

	${({ isFrozen }) =>
		isFrozen &&
		css`
			background-color: ${Colors.gray.lightest} !important;
			color: ${Colors.gray.medium} !important;
			cursor: default;
			pointer-events: none;

			.card-more-icon {
				visibility: hidden !important;
			}
			* {
				color: ${Colors.gray.medium} !important;
			}
		`}
`;

export const Wrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	flex: 1;
	width: 100%;
	overflow-x: auto;

	@media ${MediaQueries.maxWidth.md} {
		margin-bottom: 2.4rem;
	}

	.table-checkbox {
		min-height: 0;
		> div {
			padding: 0 1.2rem;
		}
	}

	.select-column {
		width: 5.6rem;
		min-width: 5.6rem;
		max-width: 5.6rem;
		border-top: 0;
	}

	.errored {
		background-color: rgba(255, 88, 93, 0.1);
	}
`;

export const IconWrapper = styled.div`
	width: 4rem;
`;

type MoreIconContainerProps = {
	visible: boolean;
};

export const MoreIconContainer = styled.div<MoreIconContainerProps>`
	visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};

	${isOnTouchDevice &&
	css`
		visibility: visible;
	`}
`;

export const TextContainer = styled.div`
	display: inline-block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	min-width: 24rem;
`;

interface StyledTableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
	isFrozen?: boolean;
	clickable?: boolean;
}

export const StyledTableRow = styled(Table.Row)<StyledTableRowProps>`
	${({ isFrozen }) =>
		isFrozen &&
		css`
			background-color: ${Colors.gray.lightest} !important;
			color: ${Colors.gray.medium} !important;
			cursor: default;
			pointer-events: none;

			&:hover {
				background-color: ${Colors.gray.lightest} !important;
			}

			td,
			span,
			div,
			p,
			a {
				color: ${Colors.gray.medium} !important;
			}
		`}
`;
